import { common } from './common.icons';

export const IconBell = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-bell ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M9.9993 20.001C11.0993 20.001 11.9993 19.101 11.9993 18.001H7.9993C7.9993 19.101 8.8993 20.001 9.9993 20.001ZM15.9993 14.001V9.00098C15.9993 5.93098 14.3693 3.36098 11.4993 2.68098V2.00098C11.4993 1.17098 10.8293 0.500977 9.9993 0.500977C9.1693 0.500977 8.4993 1.17098 8.4993 2.00098V2.68098C5.6393 3.36098 3.9993 5.92098 3.9993 9.00098V14.001L1.9993 16.001V17.001H17.9993V16.001L15.9993 14.001ZM13.9993 15.001H5.9993V9.00098C5.9993 6.52098 7.5093 4.50098 9.9993 4.50098C12.4893 4.50098 13.9993 6.52098 13.9993 9.00098V15.001ZM5.5793 2.08098L4.1493 0.650977C1.7493 2.48098 0.169297 5.30098 0.0292969 8.50098H2.0293C2.1793 5.85098 3.5393 3.53098 5.5793 2.08098ZM17.9693 8.50098H19.9693C19.8193 5.30098 18.2393 2.48098 15.8493 0.650977L14.4293 2.08098C16.4493 3.53098 17.8193 5.85098 17.9693 8.50098Z"
        fill="currentColor"
      />
    </svg>
  );
};
